import React, { useEffect, useState } from 'react';
import Navbar from '../../Components/Common/Navbar';
import Footer from '../../Components/Common/Footer';
import { Container } from '../../Components/ui/Container';
import { Button } from '../../Components/ui/Button';
import { useIsMobile } from '../../Hooks/useIsMobile';
import { COUPONS } from '../../Constants/Packages';
import { CustomSelect, CustomSelectItem } from '../../Components/Common/CustomSelect';
import { Label } from '../../Components/ui/Label';
import { DatePicker } from '../../Components/Common/DatePicker';
import { AlertBox } from '../../Components/Common/AlertBox';
import { cn } from '../../lib/cn';
import { format } from 'date-fns';
import { getImagePath, checkLPData, isIOSMobileDevice } from '../../Utils/Utilities';
import IOSRestrictedModal from '../../Components/Common/IOSRestrictedModal';
import { getActiveFdbkOffer } from '../../Utils/OfferEngine';
import { PACKAGES, getOfferPrice, currPage, PAGE_EDITION_MAPPER } from '../../Constants/Packages';
import { DemoBookingFlow } from '../Demo/BookDemo';
import apiService from '../../Utils/APIService';
import { useSearchParams } from 'react-router-dom';
import { useBrand } from '../../Utils/BrandContext';


const FeedBack = ({ brand }) => {
    const isMobile = useIsMobile();
    const { brand: activeBrand } = useBrand()
    const [showIOSModal, setShowIOSModal] = useState(false);

    // Get query parameters
    const getQueryParam = (param) => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    };

    const [searchParams] = useSearchParams();
    useEffect(() => {
        checkLPData('feedback', searchParams);
    }, []);

    const isInteractionMode = getQueryParam('Ixn') === '1';
    const agentName = getQueryParam('agent') || '';

    const [selectedOption, setSelectedOption] = useState(null);
    const [feedbackText, setFeedbackText] = useState('');
    const [interactionFeedback, setInteractionFeedback] = useState({
        helpfulness: null,
        enjoyment: null,
        clarity: null,
        wouldRecommend: null,
        overallRating: null
    });
    const [showThankYou, setShowThankYou] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [showBusinessQuestions, setShowBusinessQuestions] = useState(null);

    const PIXEL_ID = "1652655355901268";
    const EVENT_NAME = "PageView";

    // --- META PIXEL INTEGRATION START ---
    useEffect(() => {
        if (window.fbq) {
        window.fbq("track", EVENT_NAME);
        return;
        }

        // Standard Meta Boilerplate (Never changes)
        const fbq = function () {
        fbq.callMethod
            ? fbq.callMethod.apply(fbq, arguments)
            : fbq.queue.push(arguments);
        };
        if (!window._fbq) window._fbq = fbq;
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = "2.0";
        fbq.queue = [];
        window.fbq = fbq;

        const script = document.createElement("script");
        script.async = true;
        script.src = "https://connect.facebook.net/en_US/fbevents.js";
        const firstScript = document.getElementsByTagName("script")[0];
        if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
        } else {
        document.head.appendChild(script);
        }

        // Use the variables here
        window.fbq("init", PIXEL_ID);
        window.fbq("track", EVENT_NAME);
    }, []);

    const handleUseCoupon = (couponCode, editionId) => {
        if (isIOSMobileDevice()) {
            setShowIOSModal(true);
            return;
        }
        const allDataRaw = localStorage.getItem('allData');
        if (!allDataRaw) return;

        const allData = JSON.parse(allDataRaw);
        const leadInfo = allData.info ? JSON.parse(allData.info) : [];
        const leadO = leadInfo[0]?.LeadO || '';
        const mobile = allData.mobile || '';

        const couponDetails = Object.values(COUPONS).find(
            (c) => c.code === couponCode && c.editionID === editionId
        );

        let selectedPeriod = "YY";
        if (couponDetails) {
            selectedPeriod = couponDetails.planYear === 1 ? "YY" : `YY${couponDetails.planYear}`;
        }

        localStorage.setItem("selEdn", editionId);
        localStorage.setItem("selPrd", selectedPeriod);
        localStorage.setItem(couponDetails?.planYear === 2 ? "cpnYY2" : "cpn", couponCode);
        localStorage.setItem("guidePG", window.location.pathname.substring(1));

        const cioData = [{ 'i': mobile, 'o': leadO }];
        localStorage.setItem('cio', JSON.stringify(cioData));
        const currentParams = window.location.search; 
        window.location.href = "/Html/External/BZPay.html" + currentParams;
    };

    const handleBackNavigation = () => {
        if (showThankYou) {
            setShowThankYou(false);
            return;
        }

        if (showBusinessQuestions) {
            setShowBusinessQuestions(false);
            return;
        }

        if (selectedOption) {
            setSelectedOption(null);
            setFeedbackText('');
            setShowBusinessQuestions(false);
            return;
        }

        window.history.back();
    };

    // Handle browser back button
    React.useEffect(() => {
        const handlePopState = (event) => {
            event.preventDefault();
            handleBackNavigation();
        };

        // Push initial state
        window.history.pushState({ page: 'initial' }, '', window.location.href);

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [selectedOption, showBusinessQuestions, showThankYou]);

    React.useEffect(() => {
        if (selectedOption) {
            window.history.pushState({ page: 'step2', option: selectedOption }, '', window.location.href);
        }
    }, [selectedOption]);

    React.useEffect(() => {
        if (showBusinessQuestions) {
            window.history.pushState({ page: 'business' }, '', window.location.href);
        }
    }, [showBusinessQuestions]);

    const getYearlyCoupons = () => {
        return Object.values(COUPONS).filter(coupon =>
            coupon.isActive &&
            coupon.planYear === 1 &&
            (coupon.editionID === 34 || coupon.editionID === 35)
        );
    };

    const getFdbkOfferPrice = () => {
        const fdbkRule = getActiveFdbkOffer();
        if (!fdbkRule) return null;
        const edition = PACKAGES[36]; // QikERP Power
        const offerPrice = getOfferPrice(edition, fdbkRule);
        const discountPct = Math.round((1 - Number(offerPrice.displayPrice.replace(/,/g, '')) / Number(offerPrice.stdPrice.replace(/,/g, ''))) * 100);
        return {
            displayPrice: offerPrice.displayPrice,
            stdPrice: offerPrice.stdPrice,
            discountPct,
            label: fdbkRule.label,
            couponCode: fdbkRule.couponCode,
        };
    };

const getFeedbackOfferPrice = () => {
        const fdbkRule = getActiveFdbkOffer();
        if (!fdbkRule) return null;
        const edition = PACKAGES[36]; // QikERP Power
        const offerPrice = getOfferPrice(edition, fdbkRule);
        const discountPct = Math.round((1 - Number(offerPrice.displayPrice.replace(/,/g, '')) / Number((offerPrice.displayPrice === edition.baseAmt ? edition.stdAmtStr : edition.baseAmtStr).replace(/,/g, ''))) * 100);
        return {
            displayPrice: offerPrice.displayPrice,
            stdPrice: offerPrice.displayPrice === edition.baseAmt ? edition.stdAmtStr : edition.baseAmtStr,
            discountPct,
            label: fdbkRule.label,
            couponCode: fdbkRule.couponCode,
            editionID: edition.id
        };
    };

    const handleFdbkOfferClick = () => {
        if (isIOSMobileDevice()) {
            setShowIOSModal(true);
            return;
        }
        const fdbkOffer = getFdbkOfferPrice();
        const allDataRaw = localStorage.getItem('allData');
        if (!allDataRaw) {
            const i = getQueryParam('i') || '';
            const o = getQueryParam('o') || '';
            window.location.href = `/QikERP/GPower?i=${i}&o=${o}&src=fdbk&s=pricing`;
            return;
        }
        const allData = JSON.parse(allDataRaw);
        const leadInfo = allData.info ? JSON.parse(allData.info) : [];
        const pkgId = 36;
        localStorage.setItem("selEdn", pkgId);
        localStorage.setItem("selPrd", "YY");
        if (fdbkOffer?.couponCode) localStorage.setItem("cpn", fdbkOffer.couponCode);
        localStorage.setItem("guidePG", window.location.pathname.substring(1));
        const cioData = [{ 'i': allData.mobile, 'o': leadInfo[0]?.LeadO }];
        localStorage.setItem('cio', JSON.stringify(cioData));
        window.location.href = "/Html/External/BZPay.html?src=fdbk";
    };

const handleFeedbackOfferClick = () => {
        if (isIOSMobileDevice()) {
            setShowIOSModal(true);
            return;
        }
        const fdbkOffer = getFeedbackOfferPrice();
        if (!fdbkOffer) return;

        const allDataRaw = localStorage.getItem('allData');
        if (!allDataRaw) {
            const i = getQueryParam('i') || '';
            const o = getQueryParam('o') || '';
            window.location.href = `/QikERP/${currPage}?i=${i}&o=${o}&src=fdbk&s=pricing`;
            return;
        }

        const allData = JSON.parse(allDataRaw);
        const leadInfo = allData.info ? JSON.parse(allData.info) : [];
        
        // 1. Set the correct Edition ID (e.g. 37)
        localStorage.setItem("selEdn", fdbkOffer.editionID);
        localStorage.setItem("selPrd", "YY");
        
        // 2. Set the Coupon (e.g. AUTOUDY) if it was resolved
        if (fdbkOffer.couponCode) {
            localStorage.setItem("cpn", fdbkOffer.couponCode);
        } else {
            localStorage.removeItem("cpn");
        }

        localStorage.setItem("guidePG", window.location.pathname.substring(1));
        
        const cioData = [{ 'i': allData.mobile, 'o': leadInfo[0]?.LeadO }];
        localStorage.setItem('cio', JSON.stringify(cioData));
        window.location.href = "/Html/External/BZPay.html?src=fdbk";
    };

    const handleSubmitFeedback = async () => {
        const i = getQueryParam('i') || '';
        const o = getQueryParam('o') || '';

        setIsSubmitting(true);
        try {
            if (!isInteractionMode) {
                const summaryParts = [];
                if (selectedOption === 'yes') summaryParts.push('Biziverse is a good fit for their business.');
                if (selectedOption === 'notsure') summaryParts.push('Not sure if Biziverse is a good fit for their business.');
                if (selectedOption === 'no') summaryParts.push('Biziverse is not a good fit for their business.');
                if (feedbackText.trim()) summaryParts.push(`What they think we missed: ${feedbackText.trim()}`);
                if (showBusinessQuestions === true) summaryParts.push('They are interested in a discount offer.');
                if (showBusinessQuestions === false) summaryParts.push('They find the pricing already affordable, no discount needed.');
                const combinedFeedback = summaryParts.join(' | ');
                await apiService.setLeadFdbkWsp(i, o, combinedFeedback);
            }
            if (isInteractionMode) {
                const ixnParts = [];
                if (interactionFeedback.overallRating) ixnParts.push(`Rating: ${interactionFeedback.overallRating}/5`);
                if (interactionFeedback.helpfulness) ixnParts.push(`Helpful: ${interactionFeedback.helpfulness}`);
                if (interactionFeedback.enjoyment) ixnParts.push(`Enjoyed: ${interactionFeedback.enjoyment}`);
                if (interactionFeedback.clarity) ixnParts.push(`Clear: ${interactionFeedback.clarity}`);
                if (interactionFeedback.wouldRecommend) ixnParts.push(`Recommend: ${interactionFeedback.wouldRecommend}`);
                if (feedbackText.trim()) ixnParts.push(`Comment: ${feedbackText.trim()}`);
                await apiService.setLeadFdbkWsp(i, o, ixnParts.join(' | '));
            }
            setShowThankYou(true);
        } catch (error) {
            console.error("Failed to send feedback alert");
            setShowThankYou(true); // Still show thank you to user even if alert fails
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleBookDemo = () => {
        // Navigate to demo booking or trigger modal
        window.location.href = '/book-demo';
    };

    const formatDateForDisplay = (dateString) => {
        if (!dateString) return "--";
        const date = new Date(dateString);
        const currentYear = new Date().getFullYear();
        const targetYear = date.getFullYear();
        const day = date.getDate();
        const monthNames = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        const month = monthNames[date.getMonth()];

        if (targetYear !== currentYear) {
            const yearShort = targetYear.toString().slice(-2);
            return `${day}-${month}-${yearShort}`;
        }

        return `${day}-${month}`;
    };

    const renderStarRating = (value, onChange) => {
        return (
            <div className="flex gap-2 justify-center">
                {[1, 2, 3, 4, 5].map((star) => (
                    <button
                        key={star}
                        onClick={() => onChange(star)}
                        className={`text-3xl transition-colors ${star <= value ? 'text-primary' : 'text-gray-300'
                            } hover:text-primary`}
                    >
                        ★
                    </button>
                ))}
            </div>
        );
    };

    const renderYesNoButtons = (value, onChange) => {
        return (
            <div className="flex gap-4 justify-center">
                <button
                    onClick={() => onChange('yes')}
                    className={`px-6 py-2 rounded font-semibold transition-all ${value === 'yes'
                        ? 'bg-primary text-white'
                        : 'bg-white border-2 border-border text-text-primary hover:border-primary'
                        }`}
                >
                    Yes
                </button>
                <button
                    onClick={() => onChange('no')}
                    className={`px-6 py-2 rounded font-semibold transition-all ${value === 'no'
                        ? 'bg-red-500 text-white'
                        : 'bg-white border-2 border-border text-text-primary hover:border-red-500'
                        }`}
                >
                    No
                </button>
            </div>
        );
    };

    // Non-Interaction Mode
    const renderPurchaseFeedback = () => {
        const now = new Date();
        const nextRoundHour = new Date(now);
        nextRoundHour.setHours(now.getHours() + 1, 0, 0, 0);

        const validTillStr = nextRoundHour.toLocaleTimeString('en-IN', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });

        const yearlyCoupons = getYearlyCoupons();
        // Step 2: Thank you + coupon panel
        if (showThankYou) {
            return (
                <div className="max-w-3xl mx-auto">
                    <div className="text-center mb-4 mt-8">
                        <div className="mb-4">
                            <i className="fas fa-check-circle text-5xl text-primary"></i>
                        </div>
                        <h2 className="text-[18px] md:text-[30px] font-bold text-text-primary mb-2">
                            Thanks so much for your feedback!
                        </h2>
                        <p className="text-[14px] md:text-base text-text-primary">
                            Here's a discount coupon that you might like!
                        </p>
                    </div>

                    {(() => {
                        const fdbkOffer = getFeedbackOfferPrice();
                        if (!fdbkOffer) return null;
                        return (
                            <div className="mb-6 md:flex justify-center">
                                <div className="border-2 border-primary bg-primary-subtle rounded-[5px] p-4 md:p-5 md:inline-block md:min-w-[340px] text-center">
                                    <p className="m-0 font-bold text-primary text-[19px] mb-1">{fdbkOffer.label}</p>
                                    <p className="text-[15px] font-semibold text-text-primary mb-3">
                                        Extra Discount on first year
                                    </p>
                                    <div className="flex items-baseline gap-1 flex-wrap mb-4 justify-center">
                                        <span className="text-[11px] text-text-secondary">₹</span>
                                        <span className="text-sm font-bold text-text-secondary line-through">{fdbkOffer.stdPrice}</span>
                                        <span className="text-[18px] text-text-secondary ml-1">₹</span>
                                        <span className="text-[28px] font-extrabold text-text-primary">{fdbkOffer.displayPrice}</span>
                                        <span className="text-[14px] text-text-secondary">+GST</span>
                                    </div>
                                    <Button
                                        onClick={handleFeedbackOfferClick}
                                        variant="primary"
                                        className="w-full md:w-auto"
                                    >
                                        <i className="fa fa-tag mr-2"></i> Get Discount Offer
                                    </Button>
                                    <div className="mt-3 text-center">
                                        <style>{`@keyframes blink { 0%, 100% { opacity: 1; } 50% { opacity: 0; } }`}</style>
                                        <p className="text-[13px]">
                                            <span className="font-bold text-red-700" style={{ animation: 'blink 1.2s step-start infinite' }}>Valid till: {validTillStr}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        );
                    })()}
                </div>
            );
        }

        // Step 1: The full feedback form (all in one scroll)
        return (
            <div className="max-w-3xl mx-auto space-y-4 md:space-y-5">
                <p className="text-[14px] md:text-base text-text-primary text-center leading-relaxed">
                    We hope you had a good chance to evaluate {activeBrand === 'bz' ? 'Biziverse' : 'QikERP'}. Please spare 2 min of your time to share your feedback so we can do better!
                </p>

                {/* Q1: Is Biziverse a good fit? */}
                <div className="bg-background-light border-2 border-border rounded-[5px] p-4 md:p-5">
                    <h3 className="text-[16px] md:text-[18px] font-bold text-text-primary mb-4 text-left">
                        Is {activeBrand === 'bz' ? 'Biziverse' : 'QikERP'} a good fit for your business?
                    </h3>
                    <div className="flex gap-3 justify-start flex-wrap">
                        {[
                            { id: 'yes', label: 'Yes' },
                            { id: 'notsure', label: 'Not Sure' },
                            { id: 'no', label: 'No' },
                        ].map((opt) => (
                            <button
                                key={opt.id}
                                onClick={() => setSelectedOption(opt.id)}
                                className={`px-5 py-2.5 rounded-[5px] border-2 font-semibold text-[14px] md:text-base transition-all ${selectedOption === opt.id
                                    ? 'bg-primary text-white border-primary'
                                    : 'bg-white border-border text-text-primary hover:border-primary'
                                    }`}
                            >
                                {opt.label}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Conditional: No or Not Sure → feedback textarea */}
                {(selectedOption === 'no' || selectedOption === 'notsure') && (
                    <div className="bg-background-light border-2 border-border rounded-[5px] p-4 md:p-5">
                        <h3 className="text-[16px] md:text-[18px] font-bold text-text-primary mb-3 text-left">
                            Uh oh! What did we miss?
                        </h3>
                        <div className="border-2 border-border rounded-[5px] overflow-hidden mt-2 hover:border-primary focus-within:border-primary transition-all">
                            <textarea
                                value={feedbackText}
                                onChange={(e) => setFeedbackText(e.target.value)}
                                placeholder="Share your thoughts here."
                                rows={4}
                                className="w-full p-3 bg-white text-text-primary focus:outline-none placeholder:text-[14px] text-[14px] placeholder:text-gray-400 resize-none"
                            />
                        </div>
                    </div>
                )}

                {/* Conditional: Yes or Not Sure → discount question */}
                {(selectedOption === 'yes' || selectedOption === 'notsure') && (
                    <div className="bg-background-light border-2 border-border rounded-[5px] p-4 md:p-5">
                        <h3 className="text-[16px] md:text-[18px] font-bold text-text-primary mb-4 text-left">
                            {selectedOption != 'notsure' ? "That's wonderful! " : ''} Would you like a discount offer?
                        </h3>
                        <div className="flex gap-3 justify-start flex-wrap">
                            {[
                                { id: 'want_discount', label: 'Yes, please!' },
                                { id: 'no_discount', label: "No, it's already easily affordable!" },
                            ].map((opt) => (
                                <button
                                    key={opt.id}
                                    onClick={() => setShowBusinessQuestions(opt.id === 'want_discount')}
                                    className={`px-5 py-2.5 rounded-[5px] border-2 font-semibold text-[14px] transition-all ${(opt.id === 'want_discount' && showBusinessQuestions === true) ||
                                        (opt.id === 'no_discount' && showBusinessQuestions === false)
                                        ? 'bg-primary text-white border-primary'
                                        : 'bg-white border-border text-text-primary hover:border-primary'
                                        }`}
                                >
                                    {opt.label}
                                </button>
                            ))}
                        </div>
                    </div>
                )}

                {/* Coupon panel when want_discount selected */}
                {showBusinessQuestions === true && yearlyCoupons.length > 0 && (
                    <div className="space-y-3">
                        {yearlyCoupons.map((coupon) => (
                            <div key={coupon.id} className="bg-background-light border-2 border-primary rounded-[5px] p-4 md:p-5">
                                <h4 className="text-base md:text-lg font-bold text-primary mb-1 text-left">
                                    {coupon.title}
                                </h4>
                                <p className="text-[14px] text-text-primary mb-3 text-left">
                                    {coupon.description}
                                </p>
                                <div className="bg-white border border-border rounded-[5px] p-3">
                                    <div className="flex items-center justify-between gap-3 flex-wrap">
                                        <div className="flex-1">
                                            <p className="text-xs text-text-secondary mb-1">Coupon Code:</p>
                                            <code className="font-mono font-bold text-base text-primary tracking-wider">
                                                {coupon.code}
                                            </code>
                                        </div>
                                        <Button
                                            onClick={() => handleUseCoupon(coupon.code, coupon.editionID)}
                                            size="sm"
                                        >
                                            <i className="fa fa-tag mr-1"></i> Get Offer
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        ))}
                        <div className="text-left px-1">
                            <p className="text-[13px]">
                                <i className="fas fa-clock mr-1 text-primary"></i>
                                <span className="font-bold text-text-primary">Valid till: {validTillStr}</span>
                            </p>
                        </div>
                    </div>
                )}

                {/* Submit Button */}
                {selectedOption && (
                    <div className="flex justify-center pt-2 pb-6">
                        <Button
                            onClick={handleSubmitFeedback}
                            size={!isMobile ? "lg" : "default"}
                            disabled={isSubmitting}
                        >
                            Submit Feedback
                        </Button>
                    </div>
                )}
            </div>
        );
    };
    // Interaction Mode
    const renderInteractionFeedback = () => {
        if (showThankYou) {
            return (
                <div className="text-center py-12">
                    <div className="mb-6">
                        <i className="fas fa-check-circle text-6xl text-primary"></i>
                    </div>
                    <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
                        Thank You for Your Feedback!
                    </h2>
                    <p className="text-lg text-text-primary">
                        We truly appreciate you taking the time to share your experience with us.
                    </p>
                </div>
            );
        }

        return (
            <div className="mb-12 ">
                {/* Header */}
                <div className="mb-12 text-center">
                    <h2 className="text-[30px] md:text-[40px] font-bold text-primary mb-4">
                        You interacted with {agentName || 'our team member'}
                    </h2>
                    <p className="text-lg md:text-xl text-text-primary">
                        We'd love to hear about your experience
                    </p>
                </div>

                {/* Feedback Questions */}
                <div className="max-w-3xl mx-auto space-y-10">
                    {/* Question 1: Overall Rating */}
                    {/* Question 1: Overall Rating */}
                    <div className="bg-background-light border-2 border-border rounded-[5px] p-5 md:p-6">
                        <h3 className="text-base md:text-lg font-bold text-text-primary mb-5 text-center">
                            How would you rate your overall interaction?
                        </h3>
                        {renderStarRating(
                            interactionFeedback.overallRating,
                            (value) => setInteractionFeedback({ ...interactionFeedback, overallRating: value })
                        )}
                    </div>

                    {/* Question 2: Helpfulness */}
                    {/* Question 1: Overall Rating */}
                    <div className="bg-background-light border-2 border-border rounded-[5px] p-5 md:p-6">
                        <h3 className="text-base md:text-lg font-bold text-text-primary mb-5 text-center">
                            Were they able to help you with your queries?
                        </h3>
                        {renderYesNoButtons(
                            interactionFeedback.helpfulness,
                            (value) => setInteractionFeedback({ ...interactionFeedback, helpfulness: value })
                        )}
                    </div>

                    {/* Question 3: Enjoyment */}
                    {/* Question 1: Overall Rating */}
                    <div className="bg-background-light border-2 border-border rounded-[5px] p-5 md:p-6">
                        <h3 className="text-base md:text-lg font-bold text-text-primary mb-5 text-center">
                            Did you enjoy talking with them?
                        </h3>
                        {renderYesNoButtons(
                            interactionFeedback.enjoyment,
                            (value) => setInteractionFeedback({ ...interactionFeedback, enjoyment: value })
                        )}
                    </div>

                    {/* Question 4: Clarity */}
                    {/* Question 1: Overall Rating */}
                    <div className="bg-background-light border-2 border-border rounded-[5px] p-5 md:p-6">
                        <h3 className="text-base md:text-lg font-bold text-text-primary mb-5 text-center">
                            Were the explanations clear and easy to understand?
                        </h3>
                        {renderYesNoButtons(
                            interactionFeedback.clarity,
                            (value) => setInteractionFeedback({ ...interactionFeedback, clarity: value })
                        )}
                    </div>

                    {/* Question 5: Recommendation */}
                    {/* Question 1: Overall Rating */}
                    <div className="bg-background-light border-2 border-border rounded-[5px] p-5 md:p-6">
                        <h3 className="text-base md:text-lg font-bold text-text-primary mb-5 text-center">
                            Would you recommend our service to others?
                        </h3>
                        {renderYesNoButtons(
                            interactionFeedback.wouldRecommend,
                            (value) => setInteractionFeedback({ ...interactionFeedback, wouldRecommend: value })
                        )}
                    </div>

                    {/* Additional Comments */}
                    {/* Question 1: Overall Rating */}
                    <div className="bg-background-light border-2 border-border rounded-[5px] p-5 md:p-6">
                        <h3 className="text-base md:text-lg font-bold text-text-primary mb-5 text-center">
                            Any additional comments or suggestions?
                        </h3>
                        <textarea
                            value={feedbackText}
                            onChange={(e) => setFeedbackText(e.target.value)}
                            placeholder="Share your thoughts (optional)..."
                            rows={5}
                            className="w-full p-3 border-2 border-primary rounded-[5px] text-sm md:text-base text-text-primary bg-background-light focus:outline-none resize-none cursor-text"
                            autoFocus />
                    </div>

                    {/* Submit Button */}
                    <div className="text-center pt-4">
                        <Button
                            onClick={handleSubmitFeedback}
                            size={!isMobile ? "lg" : "default"}
                            disabled={!interactionFeedback.overallRating}
                        >
                            Submit Feedback
                        </Button>
                    </div>
                </div>
            </div>
        );
    };

    const featuresWithIcons = [
        { name: 'CRM', icon: 'fa fa-users' },
        { name: 'Quotes', icon: 'fas fa-file-alt' },
        { name: 'Orders', icon: 'fas fa-box' },
        { name: 'Billing', icon: 'fas fa-money-bill-wave' },
        { name: 'E-Way Bill', icon: 'fas fa-truck' },
        { name: 'E-Invoice', icon: 'fas fa-file-invoice' },
        { name: 'Accounts', icon: 'fas fa-inr' },
        // {name: 'GSTR1 & 3B', icon: 'fas fa-landmark' },
        { name: 'Recovery', icon: 'fas fa-hand-holding-usd' },
        { name: 'Inventory', icon: 'fas fa-warehouse' },
        // {name: 'Batches', icon: 'fas fa-layer-group' },
        // {name: 'BOM', icon: 'fas fa-clipboard-list' },
        // {name: 'Purchase Orders', icon: 'fa fa-shopping-cart' },
        // {name: 'Suppliers Invoices', icon: 'fas fa-user-tie' },
        // {name: 'MRP', icon: 'fas fa-calculator' },
        { name: 'Projects', icon: 'fas fa-project-diagram' },
        { name: 'Manufacturing', icon: 'fas fa-industry' },
        // {name: 'Tasks', icon: 'fas fa-tasks' },
        // {name: 'Support Ticketing', icon: 'fas fa-headset' },
        // {name: 'Contracts', icon: 'fas fa-file-contract' },
    ];

    const handleBuyNow = () => {
        const i = getQueryParam('i') || '';
        const o = getQueryParam('o') || '';
        window.location.href = `/QikERP/Guide?i=${i}&o=${o}&z=offer`;
    };

    return (
        <div className="min-h-screen bg-white md:pt-16 flex flex-col">
            <noscript>
                <img
                    height="1"
                    width="1"
                    style={{ display: "none" }}
                    src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=${EVENT_NAME}&noscript=1`}
                />
            </noscript>
            {!isMobile && <Navbar logo={brand === 'bz' ? getImagePath("/Images/Biziverse.png") : getImagePath("/Images/QikERP.png")} onBuyNowClick={handleBuyNow} showBuyNow={true} />}

            <main className="flex-grow flex" id="feedback-main">
                <section className="bg-white pt-8 md:pt-16 lg:pt-20 w-full">
                    {!isMobile ? (
                        <div className="w-full max-w-[1600px] mx-auto px-8">
                            <div className="grid grid-cols-2 gap-16 items-start">
                                {/* Left Column - Brand Panel */}
                                <div className="flex flex-col justify-start sticky top-20 pt-0">
                                    {/* Logo */}
                                    <div className="flex flex-col items-start mb-8">
                                        {brand === 'bz' ? (
                                            <img
                                                src={getImagePath("/Images/Biziverse.png")}
                                                alt="Biziverse"
                                                className="h-[95px] w-auto object-contain"
                                            />
                                        ) : (
                                            <div className="relative inline-flex flex-col items-start">
                                                <img
                                                    src={getImagePath("/Images/QikERP.png")}
                                                    alt="QikERP"
                                                    className="h-[95px] w-auto object-contain"
                                                />
                                                <div className="flex flex-col items-center absolute" style={{ bottom: '-38px', right: '8px' }}>
                                                    <span className="text text-primary font-bold leading-none mb-0.5">by</span>
                                                    <img
                                                        src={getImagePath("/Images/Biziverse.png")}
                                                        alt="Biziverse"
                                                        className="h-[32px] w-auto object-contain"
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        <div className="h-[38px]" />
                                    </div>

                                    {/* Tagline */}
                                    <h1 className="text-[40px] font-bold text-left !leading-[1.25] mb-8">
                                        <span className="text-primary">Easy</span> & <span className="text-primary">Powerful</span> Tools to
                                        <br />
                                        <span className="text-primary">Accelerate Business</span>
                                    </h1>


                                    {/* Feature Tags */}
                                    <div className="flex flex-wrap gap-3 mb-10">
                                        {featuresWithIcons.map((feature, idx) => (
                                            <div key={idx} className="flex items-center gap-2 border border-border rounded px-3 py-2 bg-white">
                                                <i className={`${feature.icon} flex-shrink-0 text-primary`} style={{ fontSize: '16px' }}></i>
                                                <span className="text-sm text-text-primary font-bold">{feature.name}</span>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Buy Now & Compare Plans Buttons */}
                                    <div className="flex gap-3">
                                        <Button
                                            type="button"
                                            variant="primary"
                                            onClick={() => {
                                                const pricingSection = document.getElementById('simplePricing');
                                                if (pricingSection) {
                                                    pricingSection.scrollIntoView({ behavior: 'smooth' });
                                                } else {
                                                    window.location.href = '/QikERP/#simplePricing';
                                                }
                                            }}
                                        >
                                            Buy Now
                                        </Button>
                                        <Button
                                            type="button"
                                            variant="secondary"
                                            onClick={() => {
                                                const pricingSection = document.getElementById('simplePricing');
                                                if (pricingSection) {
                                                    pricingSection.scrollIntoView({ behavior: 'smooth' });
                                                } else {
                                                    window.location.href = '/QikERP/#simplePricing';
                                                }
                                            }}
                                        >
                                            Compare Plans
                                        </Button>
                                    </div>
                                </div>

                                {/* Right Column - Feedback Content */}
                                <div className="py-4 pt-0">
                                    <h1 className="text-[40px] font-bold text-primary mb-4 text-center">
                                        {(selectedOption === 2 || selectedOption === 3) ? 'Book a Free Demo' : 'Feedback Request'}
                                    </h1>
                                    {isInteractionMode ? renderInteractionFeedback() : renderPurchaseFeedback()}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <Container>
                            {/* Mobile: Logo + by Biziverse stacked */}
                            <div className="flex flex-col items-center mb-6 pt-5">
                                {brand === 'bz' ? (
                                    <img
                                        src={getImagePath("/Images/Biziverse.png")}
                                        alt="Biziverse"
                                        className="h-[70px] w-auto object-contain"
                                    />
                                ) : (
                                    <div className="relative inline-flex flex-col items-center">
                                        <img
                                            src={getImagePath("/Images/QikERP.png")}
                                            alt="QikERP"
                                            className="h-[120px] w-auto object-contain"
                                        />
                                        <div className="flex flex-col items-center absolute" style={{ bottom: '-17px', right: '36px' }}>
                                            <span className="text-sm text-primary font-bold leading-none mb-0.5">by</span>
                                            <img
                                                src={getImagePath("/Images/Biziverse.png")}
                                                alt="Biziverse"
                                                className="h-[26px] w-auto object-contain"
                                            />
                                        </div>
                                    </div>
                                )}
                                <div className="h-[38px]" />
                            </div>
                            {/* Mobile: Main Heading */}
                            <h1 className="text-[22px] font-bold text-text-primary text-center mb-4">
                                {(selectedOption === 2 || selectedOption === 3) ? 'Book a Free Demo' : 'Feedback Request'}
                            </h1>

                            {isInteractionMode ? renderInteractionFeedback() : renderPurchaseFeedback()}
                        </Container>
                    )}
                </section>
            </main>
            <Footer className="!bg-background-light" />
            <IOSRestrictedModal isOpen={showIOSModal} onClose={() => setShowIOSModal(false)} />
        </div>
    );
};

export default FeedBack;